import { Component } from '@angular/core';
import { Subscriber } from '../../models/shared/subscriber-model'
import { SubscriberService } from '../../services/others/subscriber.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
  selector: 'app-edit-subscribers',
  templateUrl: './edit-subscribers.component.html',
  styleUrls: ['./edit-subscribers.component.scss']
})
/** edit-subscriber component*/
export class EditSubscribersComponent {
  subscriberModel = new Subscriber();
  subscriberID: string;
  errorMessage: any;
  public createdDateElement: any;
   /** edit-subscribers ctor */
  constructor(private readonly service: SubscriberService, private readonly activatedRoute: ActivatedRoute,
    private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.rolePermissionService.GetRolePermissions("subscriber").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.activatedRoute.params.subscribe((params: Params) => {
              this.subscriberID = params['id'];
            });
            this.getsubscriber(this.subscriberID);
          }
          else {
            this.router.navigate(["/Subscribers"]);
          }
        }
        else {
          this.router.navigate(["/Subscribers"]);
        }
      }
    )
  }
  ngSubmit() {
    this.createdDateElement = document.getElementById("createdDate") as HTMLElement;
    this.subscriberModel.createdDate = this.createdDateElement.value;
    this.service.updateSubscriber(this.subscriberModel);
  }
  getsubscriber(subscriberid: string) {
    this.service.getSubscriber(subscriberid).subscribe(
      data => {
        this.subscriberModel = data
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/subscribers/edit-subscribers/edit-subscribers.component.ts